import React, { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { ContestPrize, IContestAwardTab } from '../../EsForm/ContestPrize';
import { GenericModal } from '../../GenericModal/GenericModal';
import { isEmpty } from '../../../utils/lodash';
import { ColorScheme, theme } from '../../../constants/theme';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { StyleSheet } from 'react-native';
import { IAwardCategory } from '../../../redux/contest/types';

interface IContestPhaseSelector extends Omit<IContestAwardTab, 'data'> {
    prizes: IAwardCategory[];
    onSubmit?: (arg?: IAwardCategory) => void;
    open: boolean;
    onClose: () => void;
}

const PrizeAwardDialogue: React.FC<IContestPhaseSelector> = ({ prizes, onSubmit, open, onClose }) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);
    const [value, setValue] = useState<IAwardCategory | undefined>();

    const handleOnSubmit = () => {
        setValue(undefined);
        onSubmit && onSubmit(value);
        onClose();
    };

    const handleOnChange = (prize: IAwardCategory, index: number) => {
        setActiveIndex(index);
        setValue(prize);
    };

    return (
        <GenericModal
            open={open}
            handleClose={onClose}
            paperStyle={{
                height: '60vh',
                width: '90vw',
            }}>
            <>
                <Stack direction="row" flexWrap="wrap" alignItems="center">
                    {!!prizes &&
                        !isEmpty(prizes) &&
                        prizes.map((prize, index) => (
                            <ContestPrize
                                data={prize}
                                key={index}
                                isSelectable
                                onSelect={() => handleOnChange(prize, index)}
                                sx={{
                                    border:
                                        activeIndex === index
                                            ? `1px solid ${theme[themeStyle].tag_white}`
                                            : 'transparent',
                                    cursor: 'pointer',
                                }}
                            />
                        ))}
                </Stack>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                    }}>
                    <Button
                        onClick={handleOnSubmit}
                        style={styles.detailsButton}
                        disabled={!value}
                        sx={{
                            textDecoration: 'none',
                            backgroundColor: theme[themeStyle].primary_orange,
                            color: theme[themeStyle].pure_black,
                            textTransform: 'none',
                            width: '100%',
                            marginTop: '10px',
                            marginBottom: '10px',
                            '&:hover': {
                                border: `2px solid ${theme[themeStyle].primary_orange}`,
                                backgroundColor: theme[themeStyle].pure_black,
                                color: theme[themeStyle].primary_orange,
                            },
                        }}>
                        Award Prize
                    </Button>
                </Box>
            </>
        </GenericModal>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        text: {
            textAlign: 'left',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: '400',
            color: theme[colorScheme].form_label,
            fontFamily: FONT_ENUM.MAIN_REGULAR,
        },
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            height: 'fit-content',
        },
        detailsButton: {
            height: '52px',
            borderRadius: 100,
            fontSize: 16,
            fontWeight: '600',
            fontFamily: FONT_ENUM.REGULAR_HEADER,
            alignItems: 'center',
            justifyContent: 'center',
        },
        customInput: {
            width: '100%',
            height: '100%',
            backgroundColor: theme[colorScheme].gray_text,
            borderRadius: 8,
            border: 'none',
        },
    });

export { PrizeAwardDialogue };
